import ApiService from './api.service';
import ApiAccountService from './api.account.service';
import ApiPanelsService from './api.panels.service';
import ApiRemoteService from './api.remote.service';
import PermissionsService from './api.premissions.service';
import WebSocket from './websocket.service';
import ExternalService from "./api.external.service";

export default angular.module(
	'app.api.services.module', [])

	.service('ApiService', ApiService)
	
	.service('ApiAccountService', ApiAccountService)
	.service('ApiPanelsService', ApiPanelsService)
	.service('ApiRemoteService', ApiRemoteService)
	.service('PermissionsService', PermissionsService)
	.service('WebSocket', WebSocket)
	.service('ExternalService', ExternalService)

	.name;


/** WEBPACK FOOTER **
 ** ./src/services/api/index.js
 **/